import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import NudgeCard from '@base/NudgeCard/NudgeCard';
import pushRoute from '@utils/pushRoute';
import { hideOnboardingPreferenceNudge } from '@actions/topologies';
import { goalLevelOnboardingStatus } from '@constants/index';
import startScreenLogo from '@images/goal/onboarding/start-screen-nudge.svg';

const GloNudge = ({ closeNudge, goalInfo, userOnboardingStatus }) => {
  const meFirstName = useSelector(({ auth }) => auth.me?.firstName) || '';

  const description = `Hey ${meFirstName}, let’s customise your ${
    goalInfo.name || ''
  } learning journey for you`;
  const btnLabel =
    userOnboardingStatus === goalLevelOnboardingStatus.NEW
      ? 'Let’s start'
      : 'Resume';

  const goToGloPreferencesPage = () => {
    pushRoute(
      '/goal/[goalSlug]/[goalUID]/preferences?nudge=true',
      `/goal/${goalInfo.slug}/${goalInfo.uid}/preferences?nudge=true`,
      null,
      'Goal Level Onboarding Nudge'
    );
  };

  const dispatch = useDispatch();

  const onCloseClick = () => {
    dispatch(hideOnboardingPreferenceNudge(goalInfo.uid || ''));
    closeNudge();
  };

  return (
    <NudgeCard
      title="Customise your learning journey"
      description={description}
      buttonText={btnLabel}
      onActionClick={goToGloPreferencesPage}
      onCloseClick={onCloseClick}
      icon={startScreenLogo}
    />
  );
};

GloNudge.propTypes = {
  closeNudge: PropTypes.func.isRequired,
  goalInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  userOnboardingStatus: PropTypes.oneOf([
    ...Object.keys(goalLevelOnboardingStatus).map(
      (key) => goalLevelOnboardingStatus[key]
    ),
    -1
  ])
};

GloNudge.defaultProps = {
  userOnboardingStatus: -1
};

export default GloNudge;
